import * as types from "./types";

// OPTIONS
// ==========================

export const addOption = (
  questionId,
  optionId,
  feedbackOptionId,
  telemetry,
) => {
  return {
    type: types.ADD_OPTION,
    payload: { questionId, optionId, feedbackOptionId, telemetry },
  };
};

export const removeOption = (questionId, optionId) => {
  return {
    type: types.REMOVE_OPTION,
    payload: { questionId, optionId },
  };
};

export const setOption = (
  questionId,
  optionId,
  feedbackOptionId,
  telemetry,
) => {
  return {
    type: types.SET_OPTION,
    payload: { questionId, optionId, feedbackOptionId, telemetry },
  };
};

// SUBOPTIONS
// ==========================

export const addSubOption = (
  questionId,
  optionId,
  subOptionId,
  feedbackOptionId,
  telemetry,
) => {
  return {
    type: types.ADD_SUB_OPTION,
    payload: { questionId, optionId, subOptionId, feedbackOptionId, telemetry },
  };
};
export const removeSubOption = (questionId, optionId, subOptionId) => {
  return {
    type: types.REMOVE_SUB_OPTION,
    payload: { questionId, optionId, subOptionId },
  };
};
export const setSubOption = (
  questionId,
  optionId,
  subOptionId,
  feedbackOptionId,
  telemetry,
) => {
  return {
    type: types.SET_SUB_OPTION,
    payload: { questionId, optionId, subOptionId, feedbackOptionId, telemetry },
  };
};

// OTHER TEXT
// ==========================

export const setOptionOtherText = (
  questionId,
  optionId,
  feedbackOptionId,
  other_text,
  telemetry,
) => {
  return {
    type: types.SET_OPTION_OTHER_TEXT,
    payload: { questionId, optionId, feedbackOptionId, other_text, telemetry },
  };
};

export const setSubOptionOtherText = (
  questionId,
  optionId,
  subOptionId,
  feedbackOptionId,
  other_text,
  telemetry,
) => {
  return {
    type: types.SET_SUB_OPTION_OTHER_TEXT,
    payload: {
      questionId,
      optionId,
      subOptionId,
      feedbackOptionId,
      other_text,
      telemetry,
    },
  };
};

export const clearQuestion = questionId => {
  return {
    type: types.CLEAR_QUESTION,
    payload: { questionId },
  };
};

export const clearSubOptions = (questionId, optionId) => {
  return {
    type: types.CLEAR_SUB_OPTIONS,
    payload: { questionId, optionId },
  };
};

// FILES
// ==========================

export const addOptionFile = (
  questionId,
  optionId,
  feedbackOptionId,
  id,
  uri,
  type,
  telemetry,
) => {
  return {
    type: types.ADD_OPTION_FILE,
    payload: {
      questionId,
      optionId,
      feedbackOptionId,
      id,
      uri,
      type,
      telemetry,
    },
  };
};

export const removeOptionFile = (questionId, optionId, id, telemetry) => {
  return {
    type: types.REMOVE_OPTION_FILE,
    payload: { questionId, optionId, id, telemetry },
  };
};

export const addSubOptionFile = (
  questionId,
  optionId,
  subOptionId,
  feedbackOptionId,
  id,
  uri,
  type,
  telemetry,
) => {
  return {
    type: types.ADD_SUB_OPTION_FILE,
    payload: {
      questionId,
      optionId,
      subOptionId,
      feedbackOptionId,
      id,
      uri,
      type,
      telemetry,
    },
  };
};

export const removeSubOptionFile = (
  questionId,
  optionId,
  subOptionId,
  id,
  telemetry,
) => {
  return {
    type: types.REMOVE_SUB_OPTION_FILE,
    payload: { questionId, optionId, subOptionId, id, telemetry },
  };
};

// FLAGS
// ==========================

export const validateSection = isValid => {
  return {
    type: types.VALIDATE_SECTION,
    payload: { isValid },
  };
};

export const setLanguageKey = languageKey => {
  return {
    type: types.SET_LANGUAGE_KEY,
    payload: languageKey,
  };
};

export const showModal = message => {
  return {
    type: types.SHOW_MODAL,
    payload: message,
  };
};

export const hideModal = () => {
  return {
    type: types.HIDE_MODAL,
  };
};

export const setQuestionScore = (questionId, score) => {
  return {
    type: types.SET_QUESTION_SCORE,
    payload: { questionId, score },
  };
};

export const setOptionError = optionId => {
  return {
    type: types.SET_OPTION_ERROR,
    payload: optionId,
  };
};

export const clearOptionError = optionId => {
  return {
    type: types.CLEAR_OPTION_ERROR,
    payload: optionId,
  };
};

export const addOptionItem = (itemId, questionId, optionId) => {
  return {
    type: types.ADD_OPTION_ITEM,
    payload: { questionId, optionId, itemId },
  };
};

export const removeOptionItem = (itemId, questionId, optionId) => {
  return {
    type: types.REMOVE_OPTION_ITEM,
    payload: { questionId, optionId, itemId },
  };
};

export const addSubOptionItem = (itemId, questionId, optionId, subOptionId) => {
  return {
    type: types.ADD_SUB_OPTION_ITEM,
    payload: { questionId, optionId, subOptionId, itemId },
  };
};

export const removeSubOptionItem = (
  itemId,
  questionId,
  optionId,
  subOptionId,
) => {
  return {
    type: types.REMOVE_SUB_OPTION_ITEM,
    payload: { questionId, optionId, subOptionId, itemId },
  };
};
